module.exports = __webpack_public_path__ + "static/media/pl.8c8ba138.svg";